document.addEventListener("DOMContentLoaded", function () {
  var sizeGuideLink = document.getElementById("size-guide-link");
  var sizeChartOverlay = document.getElementById("size-chart-overlay");
  var sizeChartClose = document.getElementById("size-chart-close");

  // Add click event listener to open the size chart overlay
  if (sizeGuideLink && sizeChartOverlay) {
    sizeGuideLink.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent the default behavior of the link
      showSizeOverlay();
    });
  }

  // Add click event listener to close the size chart overlay
  if (sizeChartClose && sizeChartOverlay) {
    sizeChartClose.addEventListener("click", function () {
      hideSizeOverlay();
    });
  }

  function showSizeOverlay() {
    // Check if the size chart overlay exists
    if (sizeChartOverlay) {
      sizeChartOverlay.style.opacity = 1;
      sizeChartOverlay.style.visibility = "visible";

      document.body.style.overflow = "hidden";
    }
  }

  function hideSizeOverlay() {
    // Check if the size chart overlay exists
    if (sizeChartOverlay) {
      sizeChartOverlay.style.opacity = 0;
      sizeChartOverlay.style.visibility = "hidden";

      document.body.style.overflow = "auto";
    }
  }
});
